import React from 'react';
import PropTypes from 'prop-types';
import ResetPasswordForm from '../ResetPassword/ResetPasswordForm';
import * as types from '../../constants/actionTypes';
import Notification from '../Common/Notification';

export class ResetPasswordSection extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            shouldShowForm: false,
            oldPassword: {
                value: '',
                errors: []
            },
            password: {
                value: '',
                errors: []
            },
            confirm: {
                value: '',
                errors: []
            }
        }
    }

    onResetPasswordFormChange = (event) => {
        const name = event.currentTarget.name;
        const value = event.currentTarget.value;
        const errors = this.getFieldErrors(name, value);
        this.setState({ [event.currentTarget.name]: { ...this.state[name], value: value, errors: errors } });
    }

    getFieldErrors = (name, value) => {
        let errors = [];
        switch (name) {
            case 'oldPassword' : {
                if (value.length < 1) {
                    errors.push('Old Password is required');
                }
                break;
            }
            case 'password': {
                if (value.length < 1) {
                    errors.push('Password is required');
                }
                break;
            }
            case 'confirm': {
                const pass = this.state.password.value;
                if (value.length < 1) {
                    errors.push('Password confirmation is required');
                } else if (pass !== value) {
                    errors.push('Passwords do not match');
                }
                break;
            }
            default:
                break;
        }
        return errors;
    }

    isResetPasswordFormValid = () => {
        const oldPasswordErrors = this.getFieldErrors('oldPassword', this.state.oldPassword.value);
        if (oldPasswordErrors.length > 0) {
            this.setState({ oldPassword: { ...this.state.oldPassword, errors: oldPasswordErrors } });
        }
        const passwordErrors = this.getFieldErrors('password', this.state.password.value);
        if (passwordErrors.length > 0) {
            this.setState({ password: { ...this.state.password, errors: passwordErrors } });
        }
        const confirmErrors = this.getFieldErrors('confirm', this.state.confirm.value);
        if (confirmErrors.length > 0) {
            this.setState({ confirm: { ...this.state.confirm, errors: confirmErrors } });
        }
        return oldPasswordErrors.length <= 0 && passwordErrors.length <= 0 && confirmErrors.length <= 0;
    }

    onResetPasswordSave = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        
        if (!this.isResetPasswordFormValid()) {
            return;
        }

        try {
            const result = await this.props.accountActions.resetPassword(this.props.userKey, null, this.state.oldPassword.value, this.state.password.value, this.state.confirm.value);
            
            if (result.type === types.RESET_PASSWORD_SUCCESS) {
                Notification("success", "Password Reset Success", "Your password has been successsfully reset");
                this.setState({
                    shouldShowForm: false,
                    oldPassword: {
                        value: '',
                        errors: []
                    },
                    password: {
                        value: '',
                        errors: []
                    },
                    confirm: {
                        value: '',
                        errors: []
                    }
                });
            } else if (result.type === types.RESET_PASSWORD_FAILURE) {
                Notification("error", "Error", result.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }
    
    onChangePasswordClick = () => {
        this.setState({ shouldShowForm: true });
    }

    render() {

        return (
            <div className="reset-password-section section">
                <div className="row content">
                    <div className="col-12 col-sm-4 header">
                        <h4>Reset Password</h4>
                        <p>Change the password you use to login to app.getpacer.com</p>
                    </div>
                    {
                        this.state.shouldShowForm
                            ?
                            <div className="col-12 col-sm-8 fields">
                                <ResetPasswordForm
                                    title="Reset Password"
                                    password={this.state.password}
                                    confirm={this.state.confirm}
                                    onSubmit={this.onResetPasswordSave}
                                    onChange={this.onResetPasswordFormChange}
                                    isTokenExpired={false}
                                    isOldPasswordRequired={true}
                                    oldPassword={this.state.oldPassword}
                                />
                            </div>
                            :
                            <div className="col-12 col-sm-8 change-password-wrapper">
                                <button name="changePassword" className="btn btn-primary save-changes" onClick={this.onChangePasswordClick}>Change Password</button>
                            </div>
                    }
                </div>
            </div>
        );
    }

}
ResetPasswordSection.propTypes = {
    userKey: PropTypes.string.isRequired,
    accountActions: PropTypes.object.isRequired,
};

export default ResetPasswordSection;

